import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcUser = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 18,
	viewBox: "0 0 17 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.5 8.50415C10.2604 8.50415 11.6875 7.07706 11.6875 5.31665C11.6875 3.55624 10.2604 2.12915 8.5 2.12915C6.73959 2.12915 5.3125 3.55624 5.3125 5.31665C5.3125 7.07706 6.73959 8.50415 8.5 8.50415ZM1.0625 14.5958C1.0625 11.6227 3.4727 9.21248 6.44583 9.21248H10.5542C13.5273 9.21248 15.9375 11.6227 15.9375 14.5958C15.9375 15.3391 15.3349 15.9417 14.5917 15.9417H2.40833C1.66505 15.9417 1.0625 15.3391 1.0625 14.5958Z",
		fill: "#D0D3DB"
	})
});
export default SvgIcUser;
